import React, { useState } from 'react';
import { XMarkIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

const files = [

    {
        title: 'Armor-Crete of Swimming Pool',
        source:
            `${require('../assets/gallery/armor/i1.jpeg')}`,
    },
    {
        title: 'Armor-Crete of Swimming Pool and Patio',
        source:
            `${require('../assets/gallery/armor/i2.jpeg')}`,
    },
    {
        title: 'Armor-Crete of Walkway',
        source:
            `${require('../assets/gallery/armor/i3.jpeg')}`,
    },
    {
        title: 'Armor-Crete of Porch',
        source:
            `${require('../assets/gallery/armor/i4.jpeg')}`,
    },
    {
        title: 'Armor-Crete of Entryway',
        source:
            `${require('../assets/gallery/armor/i5.jpeg')}`,
    },
    {
        title: 'Armor-Crete of Swimming Pool walkway',
        source:
            `${require('../assets/gallery/armor/i6.jpeg')}`,
    },
    {
        title: 'Armor-Crete basement parging',
        source:
            `${require('../assets/gallery/armor/i7.jpg')}`,
    },
    {
        title: 'Porch',
        source:
            `${require('../assets/gallery/armor/i8.jpeg')}`,
    },
    {
        title: 'Porch with fake tiles design view with the door',
        source:
            `${require('../assets/gallery/armor/i9.jpeg')}`,
    },
    {
        title: 'Porch with fake tiles design closer look',
        source:
            `${require('../assets/gallery/armor/i10.jpeg')}`,
    },
    {
        title: 'Pool deck',
        source:
            `${require('../assets/gallery/armor/i11.jpeg')}`,
    },
    {
        title: 'Side of the house',
        source:
            `${require('../assets/gallery/armor/i12.jpeg')}`,
    },
    {
        title: 'Swimming pool deck',
        source:
            `${require('../assets/gallery/armor/i13.jpeg')}`,
    },
    {
        title: 'Porch and the patio',
        source:
            `${require('../assets/gallery/armor/i14.jpeg')}`,
    }
]

function Armorportfolio() {

    const [selectedImage, setSelectedImage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const openPopover = (index) => {
        setSelectedImage(files[index].source);
        setCurrentIndex(index);
        setIsPopoverOpen(true);
    };

    const closePopover = () => {
        setSelectedImage(null);
        setCurrentIndex(null);
        setIsPopoverOpen(false);
    };

    const nextImage = () => {
        const nextIndex = currentIndex === files.length - 1 ? 0 : currentIndex + 1;
        setSelectedImage(files[nextIndex].source);
        setCurrentIndex(nextIndex);
    };

    const previousImage = () => {
        const previousIndex = currentIndex === 0 ? files.length - 1 : currentIndex - 1;
        setSelectedImage(files[previousIndex].source);
        setCurrentIndex(previousIndex);
    };

    return (
        <>
            <section className="bg-green-50 p-4 mb-8">
                <h2 className="text-2xl font-bold text-center">Our Projects - scroll down to see more</h2>
                <ul className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-3 xl:gap-x-8 px-16 lg:px-32 max-h-64 overflow-y-scroll">
                    {files.map((file, index) => (
                        <li key={file.source} className="relative">
                            <div className="group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-green-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 mt-1 mb-1">
                                <img src={file.source} alt={file.title} className="pointer-events-none object-cover group-hover:opacity-75" />


                                <button
                                    type="button"
                                    className="absolute inset-0 focus:outline-none"
                                    onClick={() => openPopover(index)}
                                >
                                    <span className="sr-only">View details for {file.title}</span>
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            </section>

            {isPopoverOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-green-50 bg-opacity-50">
                    <div className="relative bg-white p-4 rounded-lg">
                        <XMarkIcon
                            aria-hidden="true"
                            className="absolute top-4 right-4 block h-6 w-6 cursor-pointer bg-black text-white rounded-full p-1 shadow-md"
                            onClick={closePopover}
                        />
                        <ChevronLeftIcon
                            aria-hidden="true"
                            className="absolute left-4 top-1/2 transform -translate-y-1/2 block h-6 w-6 cursor-pointer bg-black text-white rounded-full p-1 shadow-md"
                            onClick={previousImage}
                        />
                        <img
                            onClick={closePopover}
                            src={selectedImage} alt=""
                            className="object-contain max-h-[calc(100vh-4rem)] max-w-[calc(100vw-4rem)] rounded-lg"
                        />
                        <ChevronRightIcon
                            aria-hidden="true"
                            className="absolute right-4 top-1/2 transform -translate-y-1/2 block h-6 w-6 cursor-pointer bg-black text-white rounded-full p-1 shadow-md"
                            onClick={nextImage}
                        />
                    </div>
                </div>
            )}
        </>
    )


};

export default Armorportfolio;